
import { Vue, Component, Prop, Watch, ModelSync } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { pipe } from "fp-ts/function";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { fold } from "fp-ts/Either";
import {
  getDataFromClipboard,
  writeToClipboard
} from "@/lib/copy-paste/copy-paste";
import { OxyClipboardData } from "@/types/copy-paste";

@Component({
  components: { Dropdown }
})
export default class OxygenCopyPastContextMenu extends Vue {
  @ModelSync("value", "input")
  syncedValue?: unknown;

  @Prop()
  name?: string;

  @Prop()
  path!: string;

  dataToPaste: OxyClipboardData | null = null;

  contextMenu = false;
  contextMenuX = 0;
  contextMenuY = 0;

  get canCopy() {
    return this.syncedValue !== null && this.syncedValue !== undefined;
  }

  get canPaste() {
    if (!this.dataToPaste) return false;
    return this.dataToPaste.path === this.path && this.dataToPaste.data;
  }

  get canClear() {
    return this.syncedValue !== null && this.syncedValue !== undefined;
  }

  @Watch("contextMenu")
  onContextMenuChange() {
    if (!this.contextMenu) {
      document.removeEventListener("mousedown", this.closeIfRightClick);
    }
  }

  openContextMenu(event: MouseEvent) {
    event.preventDefault();

    this.contextMenu = false;
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;

    this.$nextTick(() => {
      this.contextMenu = true;
      this.updateCanPaste();
      document.addEventListener("mousedown", this.closeIfRightClick);
    });
  }

  closeIfRightClick(event: MouseEvent) {
    if (event.button === 2) {
      this.contextMenu = false;
    }
  }

  copyData() {
    console.log("Copy data", this.syncedValue);

    const dataToCopy = {
      oxy: {
        path: this.path,
        data: this.syncedValue
      }
    };

    pipe(
      dataToCopy,
      fpJsonStringify,
      fold(
        e => console.error("Failed to copy", ...e.map(err => err.toString())),
        jsonToStoreOnClipboard => writeToClipboard(jsonToStoreOnClipboard)
      )
    );

    this.updateCanPaste();
  }

  pasteData() {
    if (!this.dataToPaste) return;
    this.syncedValue = this.dataToPaste.data;
  }

  clearData() {
    this.syncedValue = null;
  }

  async updateCanPaste() {
    this.dataToPaste = (await getDataFromClipboard())?.oxy || null;
  }

  beforeDestroy() {
    document.removeEventListener("mousedown", this.closeIfRightClick);
  }
}
